import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppBottomNav } from "./AppBottomNav";
import { ConnectionWarningBanner } from "../ConnectionWarningBanner";

export function AppLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="native-app-stage min-h-[100dvh] bg-[radial-gradient(circle_at_top_left,rgba(31,118,120,0.18),transparent_24%),radial-gradient(circle_at_top_right,rgba(198,161,90,0.2),transparent_24%),linear-gradient(180deg,#efe7db_0%,#e8decb_100%)] px-0 md:px-5 md:py-5">
      <a
        href="#app-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-stone-950"
      >
        Перейти к приложению
      </a>

      <div className="native-app-frame relative mx-auto flex min-h-[100dvh] max-w-[430px] flex-col bg-[rgba(249,244,236,0.96)] text-stone-950 md:min-h-[calc(100dvh-2.5rem)] md:rounded-[2.8rem] md:border md:border-white/60 md:shadow-[0_36px_88px_-48px_rgba(27,53,52,0.56)]">
        <div className="native-app-glow pointer-events-none absolute inset-x-0 top-0 h-44 bg-[radial-gradient(circle_at_top,rgba(31,118,120,0.14),transparent_60%)]" />
        <div className="pointer-events-none absolute left-1/2 top-4 h-1.5 w-20 -translate-x-1/2 rounded-full bg-stone-950/10 md:top-5" />

        <ConnectionWarningBanner tone="app" />

        <main id="app-content" className="relative flex-1">
          <Outlet />
        </main>

        <AppBottomNav />
      </div>
    </div>
  );
}
